import { render, staticRenderFns } from "./WPTextInfoBlock.vue?vue&type=template&id=2d5b8642"
import script from "./WPTextInfoBlock.vue?vue&type=script&lang=ts"
export * from "./WPTextInfoBlock.vue?vue&type=script&lang=ts"
import style0 from "./WPTextInfoBlock.vue?vue&type=style&index=0&id=2d5b8642&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports